import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES_ARRAY } from '@app/core/constants/app.constants';
import { filter, interval, merge, of, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenMonitorService {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private authService = inject(AuthService);

  constructor() {
    this.router.events
      .pipe(
        // NOTE cuando finaliza la navegación,
        // más adelante obtenemos la url actual real y no la raiz /,'' que es la que se emite al inicio de la navegación
        filter((event) => event instanceof NavigationEnd),
        switchMap(() =>
          merge(
            of(null), // Emite inmediatamente tras la navegación
            interval(300000) // Y luego cada 5 minutos
          )
        ),
        tap(() => this.checkToken()),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private checkToken() {
    const currentRoute = this.router.url.replace(/^\//, '');
    const isPublicRoute = PUBLIC_ROUTES_ARRAY.some((route) =>
      currentRoute.startsWith(route)
    );
    if (isPublicRoute) {
      return;
    }
    // NOTE: hacemos esto para cuando el usuario se queda en la misma página y esa página es privada
    // comprobamos si el token ha expirado y echamos al usuario fuera de la aplicación
    if (!this.authService.isUserLoggedIn()) {
      this.authService.logout();
    }
  }
}
